/**
 * Tenant user roles returned by the login API (`account_type` field).
 */
export enum AccountType {
  ADMIN = 'ADMIN',
  MAKER = 'MAKER',
  CHECKER = 'CHECKER',
}

export const ACCOUNT_TYPE_VALUES: readonly AccountType[] = [
  AccountType.ADMIN,
  AccountType.MAKER,
  AccountType.CHECKER,
];

export function parseAccountType(value: unknown): AccountType | null {
  if (typeof value !== 'string') {
    return null;
  }
  const normalized = value.trim().toUpperCase();
  return ACCOUNT_TYPE_VALUES.find((role) => role === normalized) ?? null;
}

export function accountTypeToRoutePrefix(accountType: AccountType): string {
  switch (accountType) {
    case AccountType.ADMIN:
      return 'admin';
    case AccountType.MAKER:
      return 'maker';
    case AccountType.CHECKER:
      return 'checker';
    default:
      return 'admin';
  }
}
